<template>
    <SbsButtonIcon
        class="AudioSeekBtn"
        v-bind="seekButtonData">
        <InlineSvg :src="seekIcon" />
        <span class="AudioSeekBtn__label">{{ seekStep }}</span>
    </SbsButtonIcon>
</template>

<script>
import InlineSvg from 'vue-inline-svg';
import SeekBackwordsIcon from '../assets/seekBackwords-icon.svg';
import SeekForwordsIcon from '../assets/seekForwords-icon.svg';

export default {
    name: 'AudioSeekBtn',
    components: {
        InlineSvg,
    },
    computed: {
        seekIcon() {
            return this.seekBtnType === 'backwards' ? SeekBackwordsIcon : SeekForwordsIcon;
        },
        seekButtonData() {
            return {
                height: '24',
                width: '24',
                backgroundTheme: 'transparent',
            };
        },
    },
    props: {
        seekBtnType: {
            type: String,
            default: 'backwards',
        },
        seekStep: {
            type: [String, Number],
            default: '',
        },
    },
};
</script>

<style lang="scss" scoped>
.AudioSeekBtn {
    position: relative;
    display: flex;
    cursor: pointer;

    &:hover {
        opacity: 0.6;
    }
}

.AudioSeekBtn__label {
    position: absolute;
    top: 50%;
    left: 50%;
    color: #74777d;
    font-weight: 600;
    font-size: 11px;
    font-family: Arial, sans-serif;
    transform: translate(-50%, -50%);
}
</style>
